import React, { useState } from 'react';
import { herstelcodesAlsTekst } from '../../utils/tweestaps';
import './Tweestaps.css';

/**
 * Toont nieuwe herstelcodes één keer, met kopiëren en downloaden. Verder pas als de
 * gebruiker aanvinkt dat hij ze bewaard heeft.
 */
function TweestapsHerstelcodes({ codes, email, onKlaar, knopTekst = 'Klaar' }) {
  const [bewaard, setBewaard] = useState(false);
  const [gekopieerd, setGekopieerd] = useState(false);
  const tekst = herstelcodesAlsTekst(codes, email);

  const kopieer = async () => {
    try {
      await navigator.clipboard.writeText(tekst);
      setGekopieerd(true);
    } catch { /* kopiëren kan geblokkeerd zijn; downloaden werkt dan nog */ }
  };

  const download = () => {
    const url = URL.createObjectURL(new Blob([tekst], { type: 'text/plain;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'testwisely-herstelcodes.txt';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  return (
    <div>
      <p className="ts-uitleg">
        Bewaar deze codes op een veilige plek, bijvoorbeeld in je wachtwoordkluis of op papier.
        Ben je je telefoon kwijt, dan log je met één van deze codes toch in. Elke code werkt één keer.
      </p>
      <ul className="ts-codes" aria-label="Herstelcodes">
        {codes.map((c) => <li key={c}>{c}</li>)}
      </ul>
      <div className="ts-knoppen" style={{ marginBottom: 14 }}>
        <button type="button" className="ts-knop ts-knop-licht" onClick={kopieer}>{gekopieerd ? 'Gekopieerd' : 'Kopiëren'}</button>
        <button type="button" className="ts-knop ts-knop-licht" onClick={download}>Downloaden</button>
      </div>
      <label className="ts-vinkje">
        <input type="checkbox" checked={bewaard} onChange={(e) => setBewaard(e.target.checked)} />
        <span>Ik heb de herstelcodes bewaard.</span>
      </label>
      <button type="button" className="ts-knop" disabled={!bewaard} onClick={onKlaar}>{knopTekst}</button>
    </div>
  );
}

export default TweestapsHerstelcodes;
